var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPclServiceBusSupply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0069b1",
    d: "M18.816 4.683 16.802 2.67a1.904 1.904 0 0 0-2.688 0l-2.689 2.689 2.014 2.014 2.014-2.014 3.363 3.363a2.861 2.861 0 0 0 0-4.037zm-13.1 8.398c.56.561 1.462.561 2.013 0l2.347-2.346-2.014-2.024-2.347 2.347c-.56.56-.56 1.463 0 2.023z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0069b1",
    d: "m14.788 7.372-.675.674-.674.675L10.418 5.7a1.408 1.408 0 0 0-2.014-.01c-.56.561-.56 1.463 0 2.014l3.021 3.021-.674.675-6.042 6.042a1.904 1.904 0 0 0 0 2.688 1.904 1.904 0 0 0 2.688 0l8.73-8.73a.946.946 0 1 0 1.34-1.34l-2.679-2.688z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPclServiceBusSupply);
export default __webpack_public_path__ + "static/media/PclServiceBusSupply.b43a42f795fb34f497fb0b13866c635a.svg";
export { ForwardRef as ReactComponent };